import React, { useState } from 'react'
import { Row, Col, Message } from 'rsuite'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { getValueFromOptions } from '../../../utils/dataUtil'

export default function ManageDurableArticlesView({ schema, onPreview, onDownload, ...props }) {
  const [fileTableData, setFileTableData] = useState(schema?.attachFiles?.values || [])

  return (
    <>
      {schema && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <b>{`${schema.attachFiles.label} : `}</b>
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              {fileTableData.length > 0 ? (
                <IncomeRecordFileTable
                  data={fileTableData}
                  deleteable={false}
                  onPreview={onPreview}
                  onDownload={onDownload}
                />
              ) : (
                ' -'
              )}
            </Col>
          </Row>

          {/* ขาย */}
          {schema?.closureTypes?.find((e) => e.closureType == 2) && (
            <>
              <Row style={{ marginTop: 40, marginBottom: 20 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ fontWeight: 550, textAlign: 'right' }}>
                  <u>{schema.commetee}</u>
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <b>{`${schema.commeteeResponsinatorName.label} : `}</b>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <div>{schema.commeteeResponsinatorName.value}</div>
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <b>{`${schema.commeteeStaffName.label} : `}</b>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <div>{schema.commeteeStaffName.value}</div>
                </Col>
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <b>{`${schema.commeteeCoordinatorName.label} : `}</b>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <div>{schema.commeteeCoordinatorName.value}</div>
                </Col>
              </Row>
            </>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <b>{`${schema.note.label} : `}</b>
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              <div style={{ wordWrap: 'break-word' }}>{schema.note.value}</div>
            </Col>
          </Row>

          {/* //ความเห็น */}
          {/* {schema.comments?.map((item) => {
            return (
              <Row style={{ marginTop: 10 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <b>{`${item.label} : `}</b>
                </Col>
                <Col lg={18} md={18} sm={24} xs={24}>
                  <Message type="info" description={item.value} />
                </Col>
              </Row>
            )
          })} */}
        </>
      )}
    </>
  )
}
